import { useQuery } from "@tanstack/react-query";

import queries from "@/queries";

export default function useRoleOfCell({
  workbookId,
  tableId,
  cellAddress,
  enabled = true,
}: {
  workbookId?: string | null;
  tableId?: string | null;
  cellAddress?: string | null;
  enabled?: boolean;
}) {
  return useQuery({
    ...queries
      .workbook(workbookId!)
      ._ctx.tables(tableId!)
      ._ctx.cells(cellAddress!)
      ._ctx.role(),
    enabled: !!workbookId && !!tableId && !!cellAddress && enabled,
    gcTime: 1000 * 60 * 60 * 24,
    staleTime: 1000 * 60 * 60 * 24,
  });
}
